import React from 'react';
import ServicesChartsDataProvider from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { subtitlesMap } from '../../Common/maps/subtitleMap';
import { QUERY_KEYS_SIH } from '../../../Common/hooks/useChartsData';
import Total from './Total';

const TotalWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'do Valor Total'
            }}
            queryConfig={{
                key: QUERY_KEYS_SIH.TOTAL,
                url: 'governanceroom/dashboard/sihsus/aih/revenueTotals'
            }}
            subtitlesMap={subtitlesMap}
        >
            <Total />
        </ServicesChartsDataProvider>
    );
};

export default TotalWrapper;
